import { MutationTree } from "vuex";
import { AppState } from "./index";
import { User } from "./types";
import { UserModel } from "@/models/usermodel";

export const mutations: MutationTree<AppState> = {
  [User.AUTHENTICATED](state) {
    state.authenticated = true;
  },
  [User.DO_LOGOUT](state) {
    state.authenticated = false;
    state.userprofile = {};
  },
  [User.SET_USERPROFILE](state, flag: UserModel) {
    state.userprofile = flag;
  },
};
